
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n/index";

export default defineComponent({
    props: {
        className: {
            type: String,
            required: false,
            default: 'd-flex align-items-center text-hover-dange btn btn-danger px-3 py-1'
        },
        to: {
            type: String,
            required: true,
            default: ""
        }
    },
    setup() {
        const { t } = useI18n();
        return { t }
    }
});
